import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Service } from 'src/app/models/all-services.model';

@Component({
  selector: 'app-service-list',
  templateUrl: './service-list.component.html',
  styleUrls: ['./service-list.component.scss'],
})
export class ServiceListComponent implements OnInit,OnChanges {
  @Input() isLoading!: boolean;
  @Input() filteredServices!: Service[];

  filteredResult: Service[] = [];

  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['filteredServices'] && changes['filteredServices'].currentValue) {
      this.filteredResult = this.filterServices(changes['filteredServices'].currentValue);
    } else {
      this.filteredResult = []; 
    }
  }
  
  filterServices(services: Service[]): Service[] {
    return services.filter(item => item.depttype != "U");
  }

}